import * as React from 'react';
import { createRef } from 'react';
import TerrificBridge from 'react-terrific-bridge';

type SliderProps = {
	modifier?: string;
	decorator?: string;
	nextText?: string;
	navChildren?: React.ReactNode;
	children?: React.ReactNode;
};

type SliderState = {
	childrenHaveChanged: boolean;
};

export default class Slider extends React.Component<SliderProps, SliderState> {
	public static displayName = 'Slider';

	private componentRef: React.RefObject<HTMLDivElement>;

	constructor(props: SliderProps) {
		super(props);
		this.componentRef = createRef();
	}

	public componentDidMount() {
		setTimeout(() => {
			TerrificBridge.registerComponent(this.componentRef.current);
		}, 10);
	}

	public componentWillUnmount(): void {
		TerrificBridge.unregisterComponent(this.componentRef.current);
	}

	public shouldComponentUpdate() {
		return true;
	}

	get modifier(): string {
		return this.props.modifier ? ` m-slider--${this.props.modifier}` : '';
	}

	get decorator(): string {
		return this.props.decorator || '';
	}

	public render() {
		const { children, navChildren, nextText } = this.props;
		return (
			<div
				className={`m-slider${this.modifier}`}
				data-t-name="Slider"
				data-t-decorator={this.decorator || undefined}
				ref={this.componentRef}
			>
				{navChildren && <div className="m-slider__nav js-m-slider__nav">{navChildren}</div>}
				{!navChildren && <div className="m-slider__nav js-m-slider__nav" data-next-text={nextText} />}
				<div className="m-slider__slider js-m-slider__slider">{children}</div>
			</div>
		);
	}
}

export type SlideProps = {
	children?: React.ReactNode;
};

export const Slide = ({ children }: SlideProps) => {
	return <div className="m-slider__slide js-m-slider__slide">{children}</div>;
};
